class ProductKnowledge extends HTMLElement {
  constructor() {
    super();
    this.tabs = this.querySelectorAll('[data-tab]');
    this.content_groups = this.querySelectorAll('[data-group]');
    this.thumbnails = this.querySelectorAll('[data-thumbnail]');
    this.sliders = this.querySelectorAll('slider-component[data-group]');
    this.index = 1;

    this.setListeners();
  }

  setListeners() {
    this.tabs.forEach(tab => {
      tab.addEventListener('click', () => {
        this.index = tab.dataset.tab;
        this.tabs.forEach(tab => tab.classList.remove('active'));
        tab.classList.add('active');

        this.content_groups.forEach(el => el.classList.remove('active'));
        const groupToShow = this.querySelectorAll(`[data-group="${this.index}"]`);
        groupToShow.forEach(el => el.classList.add('active'));
      });
    });

    this.thumbnails.forEach(thumbnail => {
      thumbnail.addEventListener('click', () => {
        const { index } = thumbnail.dataset;
        const group = thumbnail.dataset.thumbGroup;
        this.updateSlidePosition(group, index);
      });
    });

    // Listen for slide changes from swipe/scroll
    this.sliders.forEach(slider => {
      slider.addEventListener('slideChanged', (event) => {
        const group = slider.dataset.group;
        const slideIndex = event.detail.currentPage;
        this.updateThumbnailState(group, slideIndex);
      });
    });
  }

  updateThumbnailState(group, slideIndex) {
    const thumbnails = this.querySelectorAll(`[data-thumbnail][data-thumb-group="${group}"]`);
    thumbnails.forEach((thumb, index) => {
      if (index + 1 === slideIndex) {
        thumb.classList.add('active');
      } else {
        thumb.classList.remove('active');
      }
    });
  }

  updateSlidePosition(group, index) {
    this.dispatchEvent(
      new CustomEvent('productKnowledge:slideChanged', {
        detail: {
          group,
          index,
        },
        bubbles: true
      })
    );
  }
}

if (!customElements.get('product-knowledge')) {
  customElements.define('product-knowledge', ProductKnowledge);
}
